import api from './api';

const adminSettingsService = {
  async getCompanySettings() {
    return api.get('/api/admin/company-settings');
  },
  async updateCompanySettings(patch) {
    return api.patch('/api/admin/company-settings', patch);
  },
  async listClosureReasons() {
    return api.get('/api/admin/closure-reasons');
  },
  async createClosureReason(payload) {
    return api.post('/api/admin/closure-reasons', payload);
  },
  async updateClosureReason(id, payload) {
    return api.patch(`/api/admin/closure-reasons/${id}`, payload);
  },
  async deleteClosureReason(id) {
    return api.delete(`/api/admin/closure-reasons/${id}`);
  },
  async listPendingReasons() {
    return api.get('/api/admin/pending-reasons');
  },
  async createPendingReason(payload) {
    return api.post('/api/admin/pending-reasons', payload);
  },
  async updatePendingReason(id, payload) {
    return api.patch(`/api/admin/pending-reasons/${id}`, payload);
  },
  async deletePendingReason(id) {
    return api.delete(`/api/admin/pending-reasons/${id}`);
  },
  async listQuickReplies() {
    return api.get('/api/admin/quick-replies');
  },
  async createQuickReply(payload) {
    return api.post('/api/admin/quick-replies', payload);
  },
  async updateQuickReply(id, payload) {
    return api.patch(`/api/admin/quick-replies/${id}`, payload);
  },
  async deleteQuickReply(id) {
    return api.delete(`/api/admin/quick-replies/${id}`);
  },
  async listTemplates() {
    return api.get('/api/admin/templates');
  },
  async createTemplate(payload) {
    return api.post('/api/admin/templates', payload);
  },
  async updateTemplate(id, payload) {
    return api.patch(`/api/admin/templates/${id}`, payload);
  },
  async deleteTemplate(id) {
    return api.delete(`/api/admin/templates/${id}`);
  },
  async listRoles() {
    return api.get('/api/admin/roles');
  },
  async listPermissions() {
    return api.get('/api/admin/permissions');
  },
  async assignRolesToUser(userId, roleIds) {
    return api.post(`/api/admin/users/${userId}/roles`, { roleIds });
  }
};

export default adminSettingsService;

